import * as RacesClient from '../clients/RacesClient'
import * as PredictionClient from '../clients/PredictionClient'
import PredictionReport from './PredictionReport'
export default class Race {
  constructor(race) {
    Object.keys(race).forEach(key => this[key] = race[key])
    if (this.report) this.report = new PredictionReport(this.report)
    if (this.horses && !this.actualWinner) {
      for (var i = 0; i < this.horses.length; i++) {
        if (this.horses[i].position === 1) {
          this.actualWinner = this.horses[i].name
          this.horses[i].winner = true
        } else {
          this.horses[i].winner = false
        }

        if (race.predictedWinner === this.horses[i].name) {
          this.horses[i].predictedWinner = true
        } else {
          this.horses[i].predictedWinner = false
        }

        if (!race.distanceInFurlongs) {
          this.distanceInFurlongs = (race.distanceAsNumber * 1 / 201).toFixed(0)
        }
      }

      this.formattedDate = this.date.split("-").join(" ")
    }
  }
  predict() {
    return new Promise((resolve, reject) => {
      return PredictionClient.getPrediction(this._id)
        .then(race => {
          race.loading = false
          Object.keys(race).forEach(key => this[key] = race[key])
          resolve()
        })
    })
  }
  meetsBetCriteria() {
    return this.shouldBet
    /*
    if (this.shouldBet) {
      return this.shouldBet
    }else {

      if (this.type === 'flat') {
        return meetsFlatCriteria(this) || meetsSprintCriteria(this)
      }

      if (this.type === 'jumps') {
        return meetsChaseCriteria(this) || meetsHurdleCriteria(this)
      }
    }
    */
  }
}

function meetsFlatCriteria(race) {
  return race.raceType === "flat" &&
    // race.horses.length >= 5 &&
    //race.horses.length <=14 &&
    !hasOddsOnHorse(race) &&
    race.class !== "flat_irish_unclassified" &&
    race.class !== "flat_unclassified" &&
    race.class !== "flat_class_1" &&
    race.class !== "flat_class_8" &&
    race.experienceCategory !== "novice" &&
    (race.predictedWinnerOdds * 1).toFixed(0) * 1 > 1 &&
    //race.distanceInFurlongs < 15 &&
    !race.isHandicap
}

function meetsSprintCriteria(race) {
  return race.raceType === "sprint" &&
    !hasOddsOnHorse(race) &&
    !race.isHandicap &&
    race.class !== "flat_irish_unclassified" &&
    race.class !== "flat_class_100" &&
    race.class !== "flat_unclassified" &&
    (race.predictedWinnerOdds * 1).toFixed(0) * 1 > 2 &&
    race.experienceCategory !== "novice" &&
    race.distanceInFurlongs * 1 !== 6
}


function meetsHurdleCriteria(race) {
  return race.raceType === "hurdle" &&
    !race.isHandicap &&
    race.classNumber * 1 !== 1 &&
    (race.predictedWinnerOdds * 1).toFixed(0) * 1 > 1 &&
    !hasOddsOnHorse(race) &&
    race.experienceCategory !== "standard"
}

function meetsChaseCriteria(race) {
  return race.raceType === "chase" &&
    !hasOddsOnHorse(race) &&
    !race.isHandicap &&
    race.class !== "jumps_unclassified" &&
    (race.predictedWinnerOdds * 1).toFixed(0) * 1 > 1 &&
    race.horses.length < 19 &&
    race.horses.length >= 4
}

function hasOddsOnHorse(race) {
  return race.horses.filter(horse => horse.oddsNumber * 1 < 1).length > 0
}
